<script>

import _ from "lodash";
import URI from "urijs";
import videojs from "video.js";

export default {
    name: "VideoPlayer",
    props: {
        src: {
            type: String,
        },
        time: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            isCanPlay: false,
        };
    },
    mounted() {
        this.player = videojs(this.$el, {
            bigPlayButton: true,
            /**
             * см. @link https://github.com/videojs/video.js/issues/5438
             */
            html5: {
                vhs: {
                    withCredentials: true,
                },
            },
            controlBar: {
                seekToLive: false,
            },
        });
        this.setCurrentTime(this.time);
    },
    computed: {
        srcProxyUrl() {
            //http://roscongress-cms-back/m3u8/stream/id1114/m3u8/22072.m3u8
            const proxyHost = process.env.VUE_APP_M3U8_PROXY_URL,
                proxyAllowed = process.env.VUE_APP_M3U8_PROXY_ALLOWED;

            if (!proxyHost || !proxyAllowed || !_.startsWith(this.src, proxyAllowed)) {
                return this.src;
            }

            let uri = new URI(this.src);

            const proxyUri = new URI(proxyHost);
            uri = uri
                .origin(proxyUri.origin())
                .path(URI.joinPaths(proxyUri.path(), uri.path()).toString());

            return uri.toString();
        },
    },
    watch: {
        time: _.debounce(function (v) {
            this.setCurrentTime(v);
        }, 400),
        srcProxyUrl(v) {
            this.isCanPlay = false;
            this.player.src(v);
            this.setCurrentTime(this.time);
        }
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose();
        }
    },
    methods: {
        setCurrentTime(v) {
            if (this.player) {
                if (this.isCanPlay) {
                    this.player.currentTime(v);
                } else {
                    this.player.one(["canplay", "play"], () => {
                        this.isCanPlay = true;
                        this.player.currentTime(v);
                    });
                }
            }
        },
    },
}
</script>

<template>
    <video controls preload="metadata" class="video-js vjs-default-skin vjs-fluid vjs-16-9">
        <source :src="srcProxyUrl" type="application/vnd.apple.mpegurl">
        <p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that
            supports HTML5 video</p>
    </video>
</template>

<style scoped lang="scss">

</style>

<style lang="css" src="video.js/dist/video-js.min.css">

</style>
